<template>
  <section class="sun not-full SectionFaq">
    <div class="title">자주하는 질문</div>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="q">Q</div>
        <div class="content">
          <div class="question">
            {{ item.question }}
          </div>
          <div class="line"></div>
          <div class="answer" v-html="item.answer"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionFaq',
  components: {},
  props: {},
  data: function () {
    return {
      list: [
        {
          question: '정말 무이자 대출인가요?',
          answer: `
            2024년 우리동네 크라우드펀딩 사업은 중소벤처기업부와 소상공인시장진흥공단이 추진하고 (주)펀다가 주관기관으로 참여하는 대출 사업입니다. 이자액에 해당하는 부분을 펀딩 종료 시점에 ‘인센티브’ 형태의 캐시백으로 환급 받을 수 있고, 본 대출의 이자액보다 환급액이 더 지급되는 형태의 대출입니다. ‘인센티브’는 마케팅 비용으로 지원됩니다.
          `,
        },
        {
          question: '상환 방식은 어떻게 되나요?',
          answer: `
            대출금액 입금일 다음날부터 매일 입금되는 카드매출의 5~10% 금원으로 일상환되며, 남은차액은 사장님의 지정계좌로 반환이 됩니다.
            `,
        },
        {
          question: '신청 조건에 기준이 있나요?',
          answer: `
            현재 운영중인 사업장에서 꾸준히 카드매출이 발생이 되어야 하며, <b>신용평점 500점 이상</b>
            일 경우 신청이 가능 합니다. 
            ※ 단, 상점주의 <b>개인 회생/신용 회복/파산/현재 연체/대출 과다</b> 와 같은 신용상 불량 정보가 확인 될 경우 진행에 제한이 있을 수 있습니다.
          `,
        },
        {
          question: '서비스 신청을 했는데 금액 입금은 언제 되는건가요?',
          answer: `
            2024년 우리동네 크라우드펀딩 진행을 위해서는 가심사 이후, 참여를 위한 필수 서류 제출
            및 카드사 제신고가 선행되어야 합니다. 카드사 제신고를 위해 계약된 은행으로 결제 계좌변경이 진행됩니다.
            <b>모든 준비가 끝나면 펀딩이 진행되며, 2~3 영업일 이내에 펀딩이 완료 됩니다.</b>
          `,
        },
      ],
    }
  },
  computed: {},
  async created() {},
  destroyed() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.SectionFaq {
  padding-top: 60px;
  padding-bottom: 30px;
  padding-left: 12px;
  padding-right: 12px;
  background-color: white;

  .title {
    width: 100%;
    font-weight: 800;
    font-size: 25px;
    letter-spacing: 0.08px;
    text-align: center;
    color: #333333;
  }

  .item {
    margin-top: 30px;
    display: flex;
    .q {
      width: 14px;
      height: 20px;
      font-weight: 800;
      font-size: 18px;
      text-align: center;
      color: #1baaf1;
    }
    .content {
      width: calc(100% - 21px);
      margin-left: 7px;
      margin-bottom: 30px;
      padding-top: 1px;
      padding-right: 6px;

      .question {
        font-weight: 800;
        font-size: 17px;
        line-height: 1.35;
        letter-spacing: -0.5px;
        color: #333333;
      }
      .line {
        width: 100%;
        height: 1px;
        background: #d7e1ea;
        margin-top: 12px;
        margin-bottom: 11px;
      }
      .answer {
        font-weight: 500;
        font-size: 15px;
        /*line-height: 1.47;*/
        line-height: 1.55;
        letter-spacing: -0.5px;
        color: #727d8c;
      }
    }
  }
}
</style>
